/**
 * Novo anexo no catálogo (#520).
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { PageShell } from '../../components';
import { documentAttachmentService } from '../../services/documentAttachmentService';
import { getApiErrorMessage } from '../../types/common';
import type { DocumentAttachmentPayload } from '../../types/documentAttachment';
import { DocumentAttachmentForm } from './components/DocumentAttachmentForm';

export const DocumentAttachmentCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const handleSubmit = async (data: DocumentAttachmentPayload) => {
    try {
      setIsSubmitting(true);
      setErro(null);
      await documentAttachmentService.create(data);
      navigate('/document-attachments');
    } catch (err: unknown) {
      setErro(getApiErrorMessage(err, 'Erro ao criar o anexo'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Anexos dos Documentos', path: '/document-attachments' },
        { label: 'Novo anexo' },
      ]}
      title="Novo anexo"
      subtitle="Documento, título, norma e o texto que sai no fim do PCMSO ou do PGR"
    >
      <Card>
        <CardContent>
          <DocumentAttachmentForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/document-attachments')}
            isSubmitting={isSubmitting}
            erro={erro}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default DocumentAttachmentCreatePage;
